<template>
  <!-- pages/address_detail/address_detail.wxml -->
  <div class="address_detail">
    <Header title="我的地址簿"></Header>

    <div class="common-wrap form">
      <div class="flex form-layer">
        <div class="form-label">收货人姓名</div>
        <input
          class="form-input"
          placeholder-class="input-placeholder"
          v-model="form.name"
          placeholder="请输入"
        />
      </div>
      <div class="flex form-layer">
        <div class="form-label">手机号</div>
        <input
          class="form-input"
          type="tel"
          placeholder-class="input-placeholder"
          v-model="form.phone"
          maxlength="11"
        />
      </div>
      <div class="flex form-layer">
        <div class="form-label">省/市/区</div>
        <div
          v-if="form.province"
          @click="show_address_pickerFun"
          class="form-picker"
        >
          {{ form.province }}{{ form.city }}{{ form.area }}
        </div>
        <div
          v-else
          @click="show_address_pickerFun"
          class="form-picker form-picker-empty"
        >
          请选择
        </div>
      </div>
      <div class="flex form-layer form-address">
        <div class="form-label">详细地址</div>
        <textarea
          placeholder-class="input-placeholder"
          v-model="form.detail_address"
          placeholder="请输入（街道、小区、门牌号）"
        />
      </div>
    </div>

    <div class="flex form_default" @click="select_default">
      <img v-if="form.is_default" src="https://oss01.dayou.art/add_selected.png" />
      <img
        v-if="!form.is_default"
        src="https://oss01.dayou.art/add_noselect.png"
      />
      设为默认地址
    </div>
    <div class="common-button btn-box" @click="handleSubmit">提交</div>

    <addressPicker
      v-if="show_address_picker"
      @close="close_address_picker"
      @change="change_address_picker"
    ></addressPicker>
  </div>
</template>

<script>
import addressPicker from "@/components/dialog/addressPicker/addressPicker";
import { updata_address, add_address } from "@/api/quanyi.js";
import { Toast } from "vant";
export default {
  components: {
    addressPicker,
  },
  data() {
    return {
      type: 0,
      step: 0,
      form: {
        name: "",
        phone: "",
        region: ["", "", ""],
        province: "",
        city: "",
        area: "",
        detail_address: "",
        is_default: 0,
      },
      route_type: 0,
      show_address_picker: false, // 是否显示地址选择器
    };
  },
  created() {
    const addressInfo = localStorage.getItem("addressInfo");
    const options = this.$route.query;
    if (addressInfo) {
      let address = JSON.parse(addressInfo);
      address.region = [address.province, address.city, address.area];
      this.form = address;
    }

    this.type = options.type;
    this.step = Number(options.step) ? 2 : 1;
    this.route_type = options.route_type || 0;

  },
  methods: {

    // 关闭地址选择器
    close_address_picker() {
      this.show_address_picker = false;
    },

    // 显示地址选择器
    show_address_pickerFun() {
      this.show_address_picker = true;
    },

    // 修改省市区
    change_address_picker(e) {
  //    console.log(e.detail, "修改省市区");
      this.show_address_picker = false;
      const arr = e.detail;
      this.form.region = arr[0].name + arr[1].name + arr[2].name;
      this.form.province = arr[0].name;
      this.form.city = arr[1].name;
      this.form.area = arr[2].name;
    },

    select_default() {
      const { form } = this;

      if (form.is_default) {
        this.form.is_default = 0;
      } else {
        this.form.is_default = 1;
      }
    },

    // 表单重置
    handleReset() {
      this.form.name = "";
      this.form.phone = "";
      this.form.region = ["", "", ""];
      this.form.detailed = "";
      this.form.is_default = 0;
    },

    // 校验表单
    valid(form) {
      const obj = {
        name: (val) => {
          if (!val.length) {
            return {
              result: false,
              message: "姓名输入有误",
            };
          }

          return {
            result: true,
          };
        },
        phone: (val) => {
          const reg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;

          if (!reg.test(val)) {
            return {
              result: false,
              message: "手机号输入有误",
            };
          }

          return {
            result: true,
          };
        },
        region: (val) => {
          if (val[0] && val[1] && val[2]) {
            return {
              result: true,
            };
          }

          return {
            result: false,
            message: "请选择省市区",
          };
        },
        detail_address: (val) => {
          if (val === "") {
            return {
              result: false,
              message: "请填写详细地址",
            };
          }

          return {
            result: true,
          };
        },
      };

      for (let key in obj) {
        let resultObj = obj[key](form[key]);

        if (!resultObj.result) {
          Toast(resultObj.message);
          return false;
        }
      }

      return true;
    },

    back_data() {
      //返回上一页携带参数
      // const step = Number(this.step) + 1 || 2;
      // let pages = getCurrentPages();
      // let prevPage = pages[pages.length - step];
      // if (prevPage.route === "subpages/pages/exchange/exchange") {
      //   prevPage.address = item
      // }
    },

    // 提交表单
    handleSubmit() {
      let form = this.form;

      if (!this.valid(form)) {
        return;
      }

      const { step, route_type } = this;
      form = Object.assign(this.form, form); // form.region = form.region.join(',')
      // form.province = form.region[0]
      // form.city = form.region[1]
      // form.area = form.region[2]
      form.detailed  =form.detail_address
      form.district = form.area
  //    console.log(form,"表单")

      if (Number(this.type)) {
        updata_address({ ...form }).then(() => {
      //    console.log(res);
          const address = JSON.parse(localStorage.getItem("addressInfo"));
          if (step == 2) {
            localStorage.setItem("wx_id", address.id);
          }
          if (route_type) {
            this.back_data(form);
          }

          Toast("修改成功");
          setTimeout(() => {
            // uni.navigateBack({
            //   url: Number(step) || 1,
            // });
            this.$router.go(-1);
          }, 1500);
        });
      } else {
        add_address({ ...form }).then((res) => {
          if (route_type) {
            this.back_data(Object.assign(res, form));
          }
          if (step == 2) {
            localStorage.setItem("wx_id", res.id);
          }

          Toast("新增成功");
          setTimeout(() => {
            // uni.navigateBack({
            //   url: Number(step) || 1,
            // });
            this.$router.go(-1);
          }, 1500);
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./address_detail.less";
</style>
